import axios from 'axios'
import { signIn } from 'next-auth/react'
import { sigV1 } from '@loc/helpers/src/sig/main'
import { ECredentialsProviderType } from '@loc/server/constant/user'

import { getNextAuthCookieNames } from '../helpers/getNextAuthCookieNames'

import { getCookies } from '@/helpers/cookies.browser'
import { getBrowserId } from '@/helpers/sig/fingerprint'

export async function anonymousSignIn() {
  const cookieNames = getNextAuthCookieNames(process.env.NEXT_PUBLIC_APP_ENV)
  const cookies = getCookies()
  // 避免特殊情况下匿名登录将登录态挤掉
  if (cookies[cookieNames.sessionTokenName]) {
    return
  }

  const deviceId = await getBrowserId()

  try {
    await axios.get('/api/auth/providers')
  } catch (err) {
    // 在 API 请求失败的时候中止匿名登录逻辑
    console.error(err)
    return
  }

  return signIn(ECredentialsProviderType.AnonymousUser, {
    deviceId,
    redirect: false,
    ...(await sigV1(deviceId)),
  })
}
